import React from 'react';
import type { CatalogEntry } from '../../services/inferenceApi';
import { isNew } from '../../utils/catalog';
import ProviderBadge from './ProviderBadge';

interface RecentlyAddedProps {
  models: CatalogEntry[];
  onInfo: (entry: CatalogEntry) => void;
}

export default function RecentlyAdded({ models, onInfo }: RecentlyAddedProps) {
  const recent = [...models]
    .filter((m) => !Number.isNaN(Date.parse(m.created_at)))
    .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at))
    .slice(0, 8);
  if (recent.length === 0) return null;
  return (
    <section aria-label="Recently added models">
      <h2 className="mb-3 text-lg font-medium text-ps-text">Recently added</h2>
      <div className="flex gap-3 overflow-x-auto pb-2 snap-x [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {recent.map((m) => (
          <button key={m.id} onClick={() => onInfo(m)}
            className="snap-start shrink-0 w-60 text-left ps-card p-4 hover:border-ps-strong transition-colors motion-reduce:transition-none">
            <div className="flex items-center gap-2 mb-2">
              {m.provider && (
                <>
                  <ProviderBadge name={m.provider} logoUrl={m.provider_logo_url} size={20} />
                  <span className="text-xs text-gray-400 truncate">{m.provider}</span>
                </>
              )}
              {isNew(m.created_at) && (
                <span className="ml-auto ps-tag ps-tag-accent">new</span>
              )}
            </div>
            <div className="text-sm font-medium text-ps-text truncate">{m.display_name}</div>
            <div className="text-xs text-ps-subtle line-clamp-2 mt-1">{m.description}</div>
          </button>
        ))}
      </div>
    </section>
  );
}
